import { PopoverContentProps } from '@reactour/tour';
import { FC, memo, ReactNode } from 'react';

export const TourContent: FC<PopoverContentProps> = memo((props) => {
    const { steps, currentStep } = props;

    const content = steps[currentStep].content;

    return typeof content === 'function' ? (content(props) as ReactNode) : content;
});

TourContent.displayName = 'TourContent';
